<script setup>
import {defineProps} from "vue";
import useHelper from "@/composables/useHelper";


const {getComplianceIconColor, getComplianceTextColor, getComplianceDateFormat, getComplianceDaysLeftTitle} = useHelper();
const props = defineProps({
    content: Object,
});
</script>

<template>
    <!-- Third item: Due Date -->
    <div class="flex items-center bg-slate-100 rounded py-2 mt-2">
        <!-- SVG Icon border-gray-400 -->
        <div class="items-center bg-slate-100 px-3 text-center ltr:border-r rtl:border-l ">
            <!-- Assuming SVG remains the same for LTR and RTL -->
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor" class="w-6 h-6 stroke-orange-80 rtl:scale-x-[-1]"
                 :class="getComplianceIconColor(props.content.due_date_left)">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
        </div>

        <!-- Text -->
        <div class="items-center px-3 text-center rtl:border-r border-gray-400">
            <h4 class="font-bold leading-1 text-blue-500" :class="getComplianceTextColor(props.content.due_date_left)">
                {{ getComplianceDaysLeftTitle(props.content.due_date_left) }}</h4>
            <p class="text-xs text-slate-400">
                <span class="font-bold">{{ $tt('content_card__details_due_date_title') }}</span>:
                {{ getComplianceDateFormat(props.content.due_date) }}
            </p>
        </div>
    </div>
</template>
